<template>
  <div>
    <ClassroomHeader @create="openCreateDialog" />
    <ClassroomTable
      :headers="headers"
      :classrooms="classrooms"
      :loading="loading"
      @edit="editItem"
      @delete="deleteItem"
    />
    <ClassroomDialog :dialog="dialog" :formTitle="formTitle" :editedItem="editedItem" @close="close" @save="save" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ClassroomHeader from '@/modules/classroom/ClassroomHeader.vue'
import ClassroomTable from '@/modules/classroom/ClassroomTable.vue'
import ClassroomDialog from '@/modules/classroom/ClassroomDialog.vue'

export default {
  components: {
    ClassroomHeader,
    ClassroomTable,
    ClassroomDialog,
  },
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Tên phòng học', value: 'name' },
        { text: 'Sức chứa', value: 'capacity' },
        { text: 'Tòa nhà', value: 'building' },
        { text: 'Tầng', value: 'floor' },
        { text: 'Cơ sở', value: 'department.title' },
        { text: 'Thao tác', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        capacity: 0,
        building: '',
        floor: '',
        department: null,
      },
      defaultItem: {
        name: '',
        capacity: 0,
        building: '',
        floor: '',
        department: null,
      },
      loading: false,
    }
  },
  computed: {
    ...mapState('classroom', ['classrooms']),
    formTitle() {
      return this.editedIndex === -1 ? 'Thêm phòng học mới' : 'Chỉnh sửa phòng học'
    },
  },
  created() {
    this.fetchClassrooms()
  },
  methods: {
    ...mapActions('classroom', ['fetch', 'create', 'update', 'delete']),
    async fetchClassrooms() {
      this.loading = true
      try {
        await this.fetch()
      } catch (error) {
        console.error('Error fetching classrooms:', error)
      } finally {
        this.loading = false
      }
    },
    openCreateDialog() {
      this.dialog = true
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    editItem(item) {
      this.editedIndex = this.classrooms.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async deleteItem(item) {
      if (confirm('Bạn có chắc chắn muốn xóa phòng học này?')) {
        try {
          await this.delete(item.id)
        } catch (error) {
          console.error('Error deleting classroom:', error)
        }
      }
    },
    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    async save() {
      try {
        if (this.editedIndex > -1) {
          await this.update({ id: this.editedItem.id, classroom: this.editedItem })
        } else {
          await this.create(this.editedItem)
        }
        this.close()
      } catch (error) {
        console.error('Error saving classroom:', error)
      }
    },
  },
}
</script>

<style scoped>
.v-data-table {
  margin-top: 20px;
}
</style>
